import { AppVideoModal } from "#components";

export const useVideoModal = () => {
  const modal = useModal();

  const openVideoModal = () => {
    modal.open(AppVideoModal);
  };

  return {
    openVideoModal,
  };
};
